import ReactECharts from 'echarts-for-react'
import { useEffect, useMemo } from 'react'
import { useGetCount, useGetTrend } from './utils'
import styled from 'styled-components'
import { t } from '@/i18n'
export const ListCollapse = (props: { record: any }) => {
  const { record } = props
  const [getCount, count] = useGetCount()
  const [getTrend, trend] = useGetTrend()
  useEffect(() => {
    getCount({
      email: record?.email,
    }).catch(err => {})
    getTrend({
      email: record?.email,
    }).catch(err => {})
  }, [record])
  const CountData = useMemo(() => {
    let obj = { phish: [], phish_total: 0, attachment: [], attachment_total: 0 }
    if (count.link_count > 0) {
      obj.phish = [
        { value: count.link_y || 0, name: t('已中招') },
        // { value: count.link_see_through || 0, name: `识破钓鱼` },
        { value: count.link_n || 0, name: t('未中招') },
      ]

      obj.phish_total = count.link_count
    }
    if (count.attach_count > 0) {
      obj.attachment = [
        { value: count.attach_y || 0, name: t('已中招') },
        // {
        //   value: count.attach_see_through || 0,
        //   name: `识破钓鱼`,
        // },
        { value: count.attach_n || 0, name: t('未中招') },
      ]

      obj.attachment_total = count.attach_count
    }
    return obj
  }, [count])
  // 处理右侧折线图
  const TrendCount = useMemo(() => {
    let arr = []
    if (trend?.num?.length > 0) {
      trend?.num?.map(item => {
        switch (item) {
          case '差':
            arr.push(25)
            break
          case '较差':
            arr.push(50)
            break
          case '良好':
            arr.push(75)
            break
          case '优秀':
            arr.push(100)
            break
        }
      })
    }
    return arr
  }, [trend])
  const option = (p: { title: string; data: any[]; total: number }) => {
    const { title, data, total } = p
    return {
      tooltip: {
        trigger: 'item',
      },
      legend: {
        bottom: '0%',
        left: 'center',
      },
      title: {
        text: title, //主标题文本
        subtext: `{title|${total}}\n{unit|${t('次任务')}}`, //副标题文本
        left: 'center',
        top: 'center',
        textVerticalAlign: 'top',
        textStyle: {
          fontSize: 14,
        },
        subtextStyle: {
          rich: {
            title: {
              fontSize: 20,
              height: 26,
              color: '#558492',
            },
            unit: {
              fontSize: 12,
              color: '#666666',
            },
          },
        },
      },
      series: [
        {
          name: data.length > 0 && title,
          type: 'pie',
          radius: ['50%', '80%'],
          // color: ['#F44F4F', '#7686A2', '#73A0FA'],
          color: ['#F44F4F', '#73A0FA'],
          data: data,
          label: {
            show: false,
            color: '#999',
          },
          emphasis: {
            itemStyle: {
              shadowOffsetX: 0,
              shadowColor: '#999999',
              scaleSize: 17,
            },
          },
        },
      ],
    }
  }
  const option1 = p => {
    const { data } = p
    return {
      xAxis: {
        type: 'category',
        data: trend?.xAxis,
        axisLabel: { interval: 0, rotate: 30 },
        nameTextStyle: {
          fontSize: 10,
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
        formatter: function (params) {
          let result = params[0].name
          params.forEach(function (item) {
            if (item.data) {
              result += `<br/><span style="background: ${
                item.color
              }; width: 11px; height: 11px; border-radius: 11px; float: left; margin: 5px 3px;"></span><span style="margin-left:8px">${
                (item.data === 25 && t('差')) ||
                (item.data === 50 && t('较差')) ||
                (item.data === 75 && t('良好')) ||
                (item.data === 100 && t('优秀'))
              }</span>`
            }
          })
          return result
        },
      },
      yAxis: {
        type: 'value',
        max: 100,
        min: 0,
        interval: 25,
        boundaryGap: true,
        axisLabel: {
          //函数模板
          formatter: function (value, index) {
            var result = ''
            switch (value) {
              case 25:
                result = t('差')
                break
              case 50:
                result = t('较差')
                break
              case 75:
                result = t('良好')
                break
              case 100:
                result = t('优秀')
                break
              default:
            }
            return result
          },
        },
      },
      grid: {
        top: '5%',
        left: '5%',
        bottom: '0%',
        right: '5%',
        containLabel: true,
      },
      series: [
        {
          data: data,
          type: 'line',
        },
      ],
    }
  }
  return (
    <Collapse>
      <div className="title">{t('个人历史任务统计')}</div>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ height: 288, flex: 1 }}>
          <div className="sub-title">
            {count.link_count > 0 && (
              <>
                {t('识破钓鱼:')} <span className="num">{count.link_see_through || 0}</span>
                {t('个')}
              </>
            )}
          </div>
          <ReactECharts
            option={option({
              title: t('钓鱼链接'),
              data: CountData.phish,
              total: CountData.phish_total,
            })}
            style={{ maxHeight: 250 }}
          />
        </div>
        <div style={{ height: 288, flex: 1 }}>
          <div className="sub-title">
            {count.attach_count > 0 && (
              <>
                {t('识破钓鱼:')} <span className="num">{count.attach_see_through || 0}</span>
                {t('个')}
              </>
            )}
          </div>
          <ReactECharts
            style={{ height: 250 }}
            option={option({
              title: t('恶意附件'),
              data: CountData.attachment,
              total: CountData.attachment_total,
            })}
          />
        </div>
        <div style={{ height: 288, flex: 2 }}>
          <ReactECharts option={option1({ data: TrendCount })} />
        </div>
      </div>
    </Collapse>
  )
}
const Collapse = styled.div`
  width: 100%;
  background-color: #fff;
  .title {
    font-weight: 600;
  }
  .sub-title {
    height: 21px;
    margin-top: 27px;
    text-align: center;
  }
  .num {
    color: #558492;
    font-size: 16px;
    font-weight: bold;
  }
`
